// extracted by mini-css-extract-plugin
export default {"container":"cU-z","topReviewHeading":"dU-z","criticalReview":"eU-z","favorableReview":"fU-z","vsSeparator":"gU-z"};